//------------- REACT IMPORT ---------------//
import React from "react";
//-------- BOOTSTRAP ITEMS IMPORT ---------//
import { Button, Card, Image, Modal } from "react-bootstrap";
//----------- IMAGES IMPORT --------------//
import { CheckedImg } from "../../../../assets/images";

const TaskModal = (props) => {
    return (
        <div>
            <Modal show={props.show} onHide={props.close} centered>
                <div className="modal_area">
                    <div className="modal_data">
                        <div className="modal_img">
                            <div className="img_one">
                                <Image src={CheckedImg} alt="..." />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal.Body>
                    <div className="message">
                        <h3>Task assigned successfully!</h3>
                        <Card>
                            <Card.Body>
                                <div className="card_data">
                                    <div className="left_area">
                                        <div className="details">
                                            <ul>
                                                <li><h5>Assign to <span>:</span></h5></li>
                                                <li><h5>Patient Name <span>:</span></h5></li>
                                                <li><h5>Task Date <span>:</span></h5></li>
                                                <li><h5>Task Time <span>:</span></h5></li>
                                                <li><h5>Task Priority <span>:</span></h5></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <ul>
                                            <li><p>Robert William, Jayden and 5 more</p></li>
                                            <li><p>Robert Syra</p></li>
                                            <li><p>15 Aug, 2023</p></li>
                                            <li><p>10:20 AM to 04:00 PM </p></li>
                                            <li><p>High</p></li>
                                        </ul>

                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="modal_btn">
                        <div className="btn_area">
                            <Button className="cancelBtn" type="button" onClick={props.close}>
                                Close
                            </Button>
                            <Button className="submitBtn" type="submit">
                                Go to listing
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default TaskModal;